// @ts-strict-ignore
export async function checkForUpdateNotification(
  addNotification,
  getIsOutdated,
  getLatestVersion,
  loadPrefs,
  savePrefs,
) {
  const latestVersion = await getLatestVersion();
  const isOutdated = await getIsOutdated(latestVersion);
  if (
    !isOutdated ||
    (await loadPrefs())['flags.updateNotificationShownForVersion'] ===
      latestVersion
  ) {
    return;
  }

  addNotification({
    type: 'message',
    title: 'A new version of Your Numbers is available!',
    message: `Version ${latestVersion} of Your Numbers was released. Refresh your browser to apply update.`,
    sticky: true,
    id: 'update-notification',
    button: {
      title: 'Reload',
      action: () => {
        window.location.reload();
      },
    },
    onClose: async () => {
      await savePrefs({
        'flags.updateNotificationShownForVersion': latestVersion,
      });
    },
  });
}
